import { Button, Divider, Input, Spinner } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { BsFillBoxSeamFill } from "react-icons/bs";
import { NewProduct } from "../../pages/Inventory/components/Product";

interface SearchProductAfterNameInterface {
  addProduct: (data: NewProduct & { id: string }) => void;
};

const SearchProductAfterName = (props: SearchProductAfterNameInterface) => {
  const { t } = useTranslation("translations");

  const [barcode, setBarcode] = useState<string>("");
  const [product, setProduct] = useState<any>([]);
  const [loadingProducts, setLoadingProducts] = useState<boolean>(false);

  const searchProduct = async (code: string) => {
    setLoadingProducts(true);
    try {
      const res = await getAxiosInstance().get("/Products/Name/" + code);
      /**
       * @Info to modify the number of existing items that will be show modify the slice range
       */
      setProduct(res.data.slice(0, 3));
    } catch (e) {
      toast.warn(t("CAN_T_FIND_PRODUCT_WITH_NAME") as string, { position: "bottom-right" });
    } finally {
      setLoadingProducts(false);
    }
  }

  const addExistingProduct = (index: number) => {
    props.addProduct({
      id: product[index].id,
      name: product[index].name,
      sku: product[index].sku,
      unitMeasurementId: product[index].unitMeasurementId,
      barcode: product[index].barCodes.length > 0 ? product[index].barCodes[0].code : "-",
      providerIds: [],
      categoriesIds: [],
      hasSerialNumber: product[index].hasSerialNumber,
      serialNumbers: product[index].serialNumbers,
    });
    setProduct([]);
    setBarcode("");
  }

  useEffect(() => {
    if (barcode.length > 3) {
      searchProduct(barcode);
    }
  }, [barcode]);

  return (
    <div className="mt-4">
      <Divider className="mb-4 mt-2" />
      <Input
        name='name'
        value={barcode}
        onChange={(e) => setBarcode(e.target.value)}
        placeholder={t("SEARCH_PRODUCT_AFTER_NAME")}
      />

      <div className={`relative mt-2 ${loadingProducts ? "bg-red-200 opacity-40 pointer-events-none" : ""}`}>
        {
          loadingProducts &&
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <Spinner />
          </div>
        }
        {
          product.map((x: any, index: number) =>
            <Button
              variant="solid"
              colorScheme='teal'
              leftIcon={<BsFillBoxSeamFill />}
              width="100%"
              onClick={() => addExistingProduct(index)}
            >
              {x.name}
            </Button>
          )
        }
      </div>
    </div>
  )
};

export default SearchProductAfterName;
